import React from 'react';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import AboutHero from '../AboutHero/AboutHero';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page">
      <Breadcrumbs items={[{ label: 'Início', to: '/' }, 'Sobre']} />
      <AboutHero />
      <main className="about-main-content">
        <div className="about-content-container">
          <section className="about-section">
            <h2 className="about-section-title">NOSSO OBJETIVO</h2>
            <div className="about-section-content">
              <p>
                Levar a cultura das ruas para além das pistas, construindo uma marca que represente atitude, personalidade e orgulho nacional.
              </p>
              <p>
                Queremos que cada peça HAKA seja mais do que roupa, seja expressão, pertencimento e confiança para quem vive o street de verdade.
              </p>
            </div>
          </section>

          <section className="about-section">
            <h2 className="about-section-title">POR QUE CONFIAR EM NÓS</h2>
            <div className="about-features">
              <div className="about-feature-box">
                <h3 className="about-feature-title">Autenticidade</h3>
                <p className="about-feature-text">Cada peça carrega originalidade, estilo e exclusividade.</p>
              </div>
              <div className="about-feature-box">
                <h3 className="about-feature-title">Produção própria</h3>
                <p className="about-feature-text">Acompanhamos cada etapa, atenção aos detalhes e compromisso real com qualidade.</p>
              </div>
              <div className="about-feature-box">
                <h3 className="about-feature-title">Brasileira</h3>
                <p className="about-feature-text">Feita no Brasil, valorizamos nossa cultura e essência.</p>
              </div>
              <div className="about-feature-box">
                <h3 className="about-feature-title">Identidade</h3>
                <p className="about-feature-text">Sobre posicionamento: quem veste HAKA mostra quem é.</p>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default AboutPage;
